import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6afnuhy79: FaireProductEntity = {
  token: "p_d6afnuhy79",
  type: "product",
  name: "Isaac Jacobs Metal Floating Picture Frame w/ Locket Closure",
  brandName: "Isaac Jacobs International",
  imageUrl:
    "https://cdn.faire.com/fastly/d2cb6e09f7cfeeef4527c1ad1e63d9bb795f919571f3c9d47ec728e3a58805b0.jpeg",
  priceDollars: 9.36,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f9b7422df750ede7b461e3d334b87fb13ccebfdb3ff4147e5ab993d403e88cce.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
